import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Button } from 'tuui';
import { AlertOIcon } from 'taboola-ultimate-ui';
import { useNavigate } from 'hooks';
import { CONVERSION_CREATION_PATH } from 'modules/PixelTester/config/pixelTesterConsts';
import { setRecommendations } from 'modules/recommendations';
import { GTM_EVENTS } from 'modules/taboola-common-frontend-modules/gtmTracker';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { useMultiLayerDrawerEnabled } from 'modules/taboola-common-frontend-modules/multi-layer-drawer/hooks/useMultiLayerDrawerEnabled';
import { CONVERSION_TYPE } from 'modules/tracking/config';
import styles from './unrecognisedEventDescription.module.scss';

export const UnrecognisedEventDescription = ({ eventData, isOnBoarding }) => {
    const isMultiLayerEnabled = useMultiLayerDrawerEnabled();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const eventName = eventData?.eventName;

    const handleCreateConversionClick = useCallback(() => {
        if (eventName) {
            const conversionName = eventName.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
            dispatch(
                setRecommendations({
                    recommendationData: {
                        type: CONVERSION_TYPE.EVENT_BASED,
                        eventName,
                        conversionName,
                    },
                })
            );
        }

        isMultiLayerEnabled
            ? navigate(CONVERSION_CREATION_PATH)
            : window.open(`${window.location.origin}${CONVERSION_CREATION_PATH}`, '_blank');
    }, [dispatch, eventName, isMultiLayerEnabled, navigate]);

    return (
        <div className={styles['container']}>
            <div className={styles['texts-container']}>
                <div className={styles['icon-title-container']}>
                    <AlertOIcon className={styles['icon']} />
                    <FormattedMessage
                        id="pixel.tester.unrecognised.event.subtitle"
                        defaultMessage="This event isn’t currently defined as a conversion."
                        className={styles['subtitle']}
                    />
                </div>
                {isOnBoarding && (
                    <FormattedMessage
                        id="pixel.tester.unrecognised.event.subtitle.onboarding"
                        defaultMessage="You will be able to fix it later in Realize"
                        className={styles['subtitle-onboarding']}
                    />
                )}
            </div>

            {!isOnBoarding && (
                <Button
                    id="PIXEL_TESTER_CREATE_CONVERSION_BTN"
                    className={styles['button']}
                    variant={Button.variant.ghost}
                    onClick={handleCreateConversionClick}
                    data-metrics-event-name={GTM_EVENTS.USABILITY}
                    data-metrics-component={UnrecognisedEventDescription.name}
                    data-metrics-value="PIXEL_TESTER_UNRECOGNIZED_EVENT_CREATE_CONVERSION"
                >
                    <FormattedMessage
                        id="pixel.tester.unrecognised.event.create.conversion.button.label"
                        defaultMessage="Create Conversion"
                    />
                </Button>
            )}
        </div>
    );
};
